import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconGreenCheck = props => {
  if (props.id !== "_svgicongreencheck") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 13 11" {...props}><path d="M11.758 1.167a.57.57 0 00-.805 0L3.768 8.35 1.972 6.555a.57.57 0 00-.805.805l2.199 2.2a.568.568 0 00.805 0l7.587-7.588a.57.57 0 000-.805" stroke="#008A44" fill="#008A44" fillRule="evenodd" /></svg>;
};

SvgIconGreenCheck.displayName = "_svgicongreencheck";
SvgIconGreenCheck.propTypes = {
  id: PropTypes.string
};
SvgIconGreenCheck.defaultProps = {
  id: ''
};
export default SvgIconGreenCheck;